import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { BootstrapPage } from './BootstrapPage';

interface BootstrapRegistrationPageProps {
  location: Location;
}

const BootstrapRegistrationPage: React.SFC<BootstrapRegistrationPageProps> = ({ location }) => {
  return <BootstrapPage flow={FlowType.register} location={location} />;
};

export { BootstrapRegistrationPage };
